firebird.controller('e2eeMeetingPhoneAudioNotSupportedCtrl', [
    'meetingService',
    function (meetingService) {
        var self = this;
        self.getAppLogoURL = meetingService.getAppLogoURL;
    }
]);
